<!-- MediaLibraryDialog.vue – دیالوگ مستقل -->
<template>
  <b-modal
      :id="modalId"
      :visible="value"
      size="xl"
      :title="title"
      hide-footer
      header-bg-variant="light"
      @hidden="onHidden"
      @shown="onShown"
      body-class="p-0"
  >
    <MediaLibraryPicker
        ref="picker"
        :multiple="multiple"
        :initial-selected-ids="initialSelectedIds"
    />

      <div class=" d-flex justify-content-end p-1 align-items-center">
        <div>
          <b-button variant="outline-secondary" class="mr-2" @click="closeModal">
            لغو
          </b-button>
        </div>
        <div>
          <b-button
              variant="primary"
              @click="selectFiles"
          >
            <i class="fas fa-check"></i> انتخاب
            <span v-if="selectedCount > 0">({{ selectedCount }})</span>
          </b-button>
        </div>
      </div>
  </b-modal>
</template>

<script>
import { BModal, BButton } from 'bootstrap-vue'
import MediaLibraryPicker from "@/views/components/Library/MediaLibraryPicker.vue";

export default {
  name: 'MediaLibraryDialog',
  components: {
    MediaLibraryPicker,
    BModal,
    BButton,
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    modalId: {
      type: String,
      default: 'media-library-dialog'
    },
    title: {
      type: String,
      default: 'کتابخانه رسانه'
    },
    multiple: {
      type: Boolean,
      default: false
    },
    initialSelectedIds: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    hasSelection() {
      return this.$refs.picker?.selectedIds?.length > 0
    },
    selectedCount() {
      return this.$refs.picker?.selectedIds?.length || 0
    }
  },
  methods: {
    onShown() {
      if (this.$refs.picker) {
        this.$refs.picker.fetchFiles()
        this.$refs.picker.selectedIds = [...this.initialSelectedIds]
      }
    },
    onHidden() {
      this.$emit('input', false)
    },
    closeModal() {
      this.$bvModal.hide(this.modalId)
    },
    selectFiles() {
      if (this.$refs.picker) {
        const selectedFiles = this.$refs.picker.getSelectedFiles()
        this.$emit('select', {
          ids: this.$refs.picker.selectedIds,
          files: selectedFiles
        })
      }
      this.closeModal()
    }
  }
}
</script>

<style scoped>
.p-0 {
  padding: 0 !important;
}
</style>
